import Lang from "../../common/lang/Lang";

export const urls = {
  home: "/settings/",
  list: "/languages/language",
}

export const ListBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.language,
    url: "#"
  }
];

export const CreateBreadcrumb = [
  {
    label: Lang.languages,
    url: urls.home
  },
  {
    label: Lang.language,
    url: urls.list
  },
  {
    label: Lang.create,
    url: '#'
  }
];

export const EditBreadcrumb = [
  {
    label: Lang.languages,
    url: urls.home
  },
  {
    label: Lang.language,
    url: urls.list
  },
  {
    label: Lang.edit,
    url: '#'
  }
];